import { confetti } from 'dom-confetti';
import 'whatwg-fetch';

import AbstractComponent from './AbstractComponent';

/**
 * Manages the request demo component.
 */
export default class RequestDemo extends AbstractComponent {
  /**
   * The HTML element of the close button.
   */
  private $closeButton?: HTMLButtonElement;

  /**
   * The HTML element of the submit button in the form.
   */
  private $submitButton: HTMLButtonElement;

  /**
   * The HTML element of the global form error.
   */
  private $formError: HTMLDivElement;

  /**
   * The HTML elements of the form's controls.
   */
  private $controls: NodeListOf<HTMLInputElement>;

  /**
   * The HTML element of the confetti wrapper.
   */
  private $confetti: HTMLElement;

  /**
   * The HTML element of the form.
   */
  private $form: HTMLFormElement;

  /**
   * Creates the request demo component.
   *
   * @param $form The form element
   */
  constructor($form: HTMLFormElement) {
    super();

    this.$form = $form;
  }

  /**
   * Initializes the request demo component.
   */
  public initialize(): void {
    this.$closeButton = this.$form.querySelector('.form__success__close');
    this.$submitButton = this.$form.querySelector('.button');
    this.$formError = this.$form.querySelector('.form__global-error');
    this.$controls = this.$form.querySelectorAll('.form__control');
    this.$confetti = this.$form.querySelector('.form__confetti');

    this.$form.addEventListener('submit', (event) => {
      this.onFormSubmit(event);
    });

    if (this.$closeButton) {
      this.$closeButton.addEventListener('click', (event) => {
        this.onCloseButtonClicked(event);
      });
    }
  }

  private onFormSubmit(event: Event): void {
    event.preventDefault();
    event.stopImmediatePropagation();

    let valid = true;

    this.$controls.forEach(($control) => {
      let fieldValid = true;

      switch ($control.getAttribute('name')) {
      case 'DemoRequest[email]':
        if (!$control.value.match(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i)) {
          fieldValid = false;
          valid = false;
        }
        break;

      default:
        if ($control.value.trim().length < 1) {
          fieldValid = false;
          valid = false;
        }
        break;
      }

      if (!fieldValid) {
        $control.classList.add('has-error');
      } else {
        $control.classList.remove('has-error');
      }
    });

    if (valid) {
      this.$submitButton.setAttribute('disabled', 'disabled');

      fetch(this.$form.action, {
        method: 'POST',
        body: new FormData(this.$form),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$submitButton.removeAttribute('disabled');

          if (this.$form.classList.contains('is-solutions-cta')) {
            const $dialogBody: HTMLElement = document.querySelector('.dialog__body');

            $dialogBody.scrollTop = 0;
            $dialogBody.style.overflow = 'hidden';
          }

          if (data.data.success) {
            if (typeof Object.assign === 'function') {
              confetti(this.$confetti, {
                startVelocity: 40,
                elementCount: 70,
                dragFriction: .12,
                perspective: '500px',
                duration: 3000,
                stagger: 3,
                spread: 360,
                height: '10px',
                width: '10px',
                angle: 90,
                colors: [
                  '#a864fd',
                  '#29cdff',
                  '#78ff44',
                  '#ff718d',
                  '#fdff6a',
                ],
              });
            }

            this.$controls.forEach(($control) => {
              if($control.type != 'hidden'){
                $control.value = '';
              }
            });

            this.$form.classList.add('has-success');
          } else {
            this.$formError.style.display = 'block';
          }
        })
        .catch((error) => {
          this.$submitButton.removeAttribute('disabled');
          this.$formError.style.display = 'block';
        });
    }
  }

  private onCloseButtonClicked(event: MouseEvent): void {
    event.preventDefault();

    this.$form.classList.remove('has-success');
  }
}
